import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import ReportTab from './tabs/ReportTab';
import HistoryTab from './tabs/HistoryTab';
import GraphTab from './tabs/GraphTab';
import * as FiIcons from 'react-icons/fi';

const { FiFileText, FiClock, FiBarChart3 } = FiIcons;

const TabsContainer = () => {
  const [activeTab, setActiveTab] = useState('report');

  const tabs = [
    { id: 'report', label: 'Report', icon: FiFileText, component: ReportTab },
    { id: 'history', label: 'History', icon: FiClock, component: HistoryTab },
    { id: 'graph', label: 'Graphs', icon: FiBarChart3, component: GraphTab },
  ];

  const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component;

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl card-shadow overflow-hidden">
      <div className="border-b border-gray-200 dark:border-gray-700">
        <nav className="flex overflow-x-auto">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center space-x-2 px-4 sm:px-6 py-3 sm:py-4 text-xs sm:text-sm font-medium transition-colors relative whitespace-nowrap ${
                activeTab === tab.id
                  ? 'text-primary-600 dark:text-primary-400 bg-primary-50 dark:bg-primary-900/20'
                  : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
              }`}
            >
              <SafeIcon icon={tab.icon} className="h-3 sm:h-4 w-3 sm:w-4" />
              <span>{tab.label}</span>
              {activeTab === tab.id && (
                <motion.div
                  layoutId="activeTab"
                  className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary-600 dark:bg-primary-400"
                />
              )}
            </button>
          ))}
        </nav>
      </div>
      <div className="p-4 sm:p-6">
        <motion.div
          key={activeTab}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.2 }}
        >
          {ActiveComponent && <ActiveComponent />}
        </motion.div>
      </div>
    </div>
  );
};

export default TabsContainer;